import React, { useContext } from 'react';

import TextBox from '../../../../ui/TextBox';
import CheckBox from '../../../../ui/CheckBox';
import DateTime from '../../../../ui/DateTime';

import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import { HblStatusViewModel } from '../../../../fms.core/HblStatusViewModel';
import BlueTitleRow from '../../../../ui/BlueTitleRow';
import Select from '../../../../ui/Select';
import BlStatusRow from '../../../common/BlStatusRow';
import ApplicationContext from '../../../../ApplicationContext';
import { now } from '../../../../dateUtils';

function HawbMilestone({
  blStatus,
  onChange,
  isView
}: {
  blStatus: HblStatusViewModel,
  onChange: (x: Partial<HblStatusViewModel>) => void,
  isView: boolean,
}) {
  const appContext = useContext(ApplicationContext);
  const user = appContext.user?.id??'';

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{marginLeft: '30px', width: '295px'}}>
          <InlineInputControlRow label="HAWB #" bold mode="smaller-2x">
            <div style={{width: '100px'}}>
              <TextBox value={blStatus.hblNo} disabled />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Departure Airport" mode="smaller-2x">
            <TextBox value={blStatus.lCode} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Arrival Airport" mode="smaller-2x">
            <TextBox value={blStatus.dCode} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Carrier" mode="smaller-2x">
            <TextBox value={blStatus.carrierName} disabled />
          </InlineInputControlRow>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel>
            &nbsp;
          </InlineInputControlRowNoLabel>

          <InlineInputControlRow label="ETD" mode="w60">
            <div style={{width: '130px'}}>
              <DateTime disabled value={blStatus.etd} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA *" mode="w60">
            <div style={{width: '130px'}}>
              <DateTime disabled value={blStatus.eta} />
            </div>
          </InlineInputControlRow>
        </div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <div style={{marginLeft: '30px'}}>
            <InlineInputControlRow label="Flight #" mode="smaller-2x">
              <div style={{width: '60px'}}>
                <TextBox disabled value={blStatus.fltNo} />
              </div>
            </InlineInputControlRow>
          </div>
        </div>
        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="OP Close"
              disabled
              checked={blStatus.opClosed}
              onToggle={() => {}}
              dateTime={blStatus.opCloseDate}
              onDateTimeChange={() => {}}
              userId={blStatus.opClosedBy}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Period Close"
              disabled
              checked={blStatus.actClosed}
              onToggle={() => {}}
              dateTime={blStatus.actClosed ? blStatus.actCloseDate : ''}
              onDateTimeChange={() => {}}
              userId={blStatus.actClosed ? blStatus.actClosedBy : ''}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>

      <div style={{marginTop: '10px'}}>
        <BlueTitleRow title={<span style={{paddingLeft: '14px'}}>B/L Status</span>} />
      </div>

      <div style={{display: 'flex'}}>
        <div style={{width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Tracker"
              disabled={isView}
              checked={!!blStatus.trackerChk}
              onToggle={trackerChk => onChange({
                trackerChk,
                trackerDate: trackerChk ? now() : null,
                trackerBy: trackerChk ? user : '',
                })}
              dateTime={blStatus.trackerDate}
              onDateTimeChange={trackerDate => onChange({trackerDate, trackerBy: trackerDate ? blStatus.trackerBy : '', trackerChk: trackerDate ? blStatus.trackerChk : false})}
              userId={blStatus.trackerBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Last Tracked"
              disabled={isView}
              checked={!!blStatus.lastTrackChk}
              onToggle={lastTrackChk => onChange({
                lastTrackChk,
                lastTrackDate: lastTrackChk ? now() : null,
                lastTrackBy: lastTrackChk ? user : '',
                })}
              dateTime={blStatus.lastTrackDate}
              onDateTimeChange={lastTrackDate => onChange({lastTrackDate, lastTrackBy: lastTrackDate ? blStatus.lastTrackBy : '', lastTrackChk: lastTrackDate ? blStatus.lastTrackChk : false})}
              userId={blStatus.lastTrackBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Book Confirm by Cust."
              disabled={isView}
              checked={!!blStatus.emptyRetChk}
              onToggle={emptyRetChk => onChange({
                emptyRetChk,
                emptyRetDate: emptyRetChk ? now() : null,
                emptyRetBy: emptyRetChk ? user : '',
                })}
              dateTime={blStatus.emptyRetDate}
              onDateTimeChange={emptyRetDate => onChange({emptyRetDate, emptyRetBy: emptyRetDate ? blStatus.emptyRetBy : '', emptyRetChk: emptyRetDate ? blStatus.emptyRetChk : false})}
              userId={blStatus.emptyRetBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Air Label"
              disabled={isView}
              checked={!!blStatus.anPrtChk}
              onToggle={anPrtChk => onChange({
                anPrtChk,
                anPrtDate: anPrtChk ? now() : null,
                anPrtBy: anPrtChk ? user : '',
                })}
              dateTime={blStatus.anPrtDate}
              onDateTimeChange={anPrtDate => onChange({anPrtDate, anPrtBy: anPrtDate ? blStatus.anPrtBy : '', anPrtChk: anPrtDate ? blStatus.anPrtChk : false})}
              userId={blStatus.anPrtBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Shipping Advice"
              disabled={isView}
              checked={!!blStatus.anSentChk}
              onToggle={anSentChk => onChange({
                anSentChk,
                anSentDate: anSentChk ? now() : null,
                anSentBy: anSentChk ? user : '',
                })}
              dateTime={blStatus.anSentDate}
              onDateTimeChange={anSentDate => onChange({anSentDate, anSentBy: anSentDate ? blStatus.anSentBy : '', anSentChk: anSentDate ? blStatus.anSentChk : false})}
              userId={blStatus.anSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Arrange Trucking"
              disabled={isView}
              checked={!!blStatus.doConfirmChk}
              onToggle={doConfirmChk => onChange({
                doConfirmChk,
                doConfirmDate: doConfirmChk ? now() : null,
                doConfirmBy: doConfirmChk ? user : '',
                })}
              dateTime={blStatus.doConfirmDate}
              onDateTimeChange={doConfirmDate => onChange({doConfirmDate, doConfirmBy: doConfirmDate ? blStatus.doConfirmBy : '', doConfirmChk: doConfirmDate ? blStatus.doConfirmChk : false})}
              userId={blStatus.doConfirmBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Pickup Cargo"
              disabled={isView}
              checked={!!blStatus.doSentChk}
              onToggle={doSentChk => onChange({
                doSentChk,
                doSentDate: doSentChk ? now() : null,
                doSentBy: doSentChk ? user : '',
                })}
              dateTime={blStatus.doSentDate}
              onDateTimeChange={doSentDate => onChange({doSentDate, doSentBy: doSentDate ? blStatus.doSentBy : '', doSentChk: doSentDate ? blStatus.doSentChk : false})}
              userId={blStatus.doSentBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Receive Cargo"
              disabled={isView}
              checked={!!blStatus.delAddrChk}
              onToggle={delAddrChk => onChange({
                delAddrChk,
                delAddrDate: delAddrChk ? now() : null,
                delAddrBy: delAddrChk ? user : '',
                })}
              dateTime={blStatus.delAddrDate}
              onDateTimeChange={delAddrDate => onChange({delAddrDate, delAddrBy: delAddrDate ? blStatus.delAddrBy : '', delAddrChk: delAddrDate ? blStatus.delAddrChk : false})}
              userId={blStatus.delAddrBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Deliver to Carrier"
              disabled={isView}
              checked={!!blStatus.ddpChk}
              onToggle={ddpChk => onChange({
                ddpChk,
                ddpDate: ddpChk ? now() : null,
                ddpBy: ddpChk ? user : '',
                })}
              dateTime={blStatus.ddpDate}
              onDateTimeChange={ddpDate => onChange({ddpDate, ddpBy: ddpDate ? blStatus.ddpBy : '', ddpChk: ddpDate ? blStatus.ddpChk : false})}
              userId={blStatus.ddpBy}
            />
          </InlineInputControlRowNoLabel>
        </div>

        <div style={{marginLeft: '30px', width: '325px'}}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="File AES"
              disabled={isView}
              checked={!!blStatus.delSchedChk}
              onToggle={delSchedChk => onChange({
                delSchedChk,
                delSchedDate: delSchedChk ? now() : null,
                delSchedBy: delSchedChk ? user : '',
                })}
              dateTime={blStatus.delSchedDate}
              onDateTimeChange={delSchedDate => onChange({delSchedDate, delSchedBy: delSchedDate ? blStatus.delSchedBy : '', delSchedChk: delSchedDate ? blStatus.delSchedChk : false})}
              userId={blStatus.delSchedBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Customs Release"
              disabled={isView}
              checked={!!blStatus.commDocChk}
              onToggle={commDocChk => onChange({
                commDocChk,
                commDocDate: commDocChk ? now() : null,
                commDocBy: commDocChk ? user : '',
                })}
              dateTime={blStatus.commDocDate}
              onDateTimeChange={commDocDate => onChange({commDocDate, commDocBy: commDocDate ? blStatus.commDocBy : '', commDocChk: commDocDate ? blStatus.commDocChk : false})}
              userId={blStatus.commDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send HAWB"
              disabled={isView}
              checked={!!blStatus.entryDocChk}
              onToggle={entryDocChk => onChange({
                entryDocChk,
                entryDocDate: entryDocChk ? now() : null,
                entryDocBy: entryDocChk ? user : '',
                })}
              dateTime={blStatus.entryDocDate}
              onDateTimeChange={entryDocDate => onChange({entryDocDate, entryDocBy: entryDocDate ? blStatus.entryDocBy : '', entryDocChk: entryDocDate ? blStatus.entryDocChk : false})}
              userId={blStatus.entryDocBy}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Send Doc Package"
              disabled={isView}
              checked={!!blStatus.f7501Chk}
              onToggle={f7501Chk => onChange({
                f7501Chk,
                f7501Date: f7501Chk ? now() : null,
                f7501By: f7501Chk ? user : '',
                })}
              dateTime={blStatus.f7501Date}
              onDateTimeChange={f7501Date => onChange({f7501Date, f7501By: f7501Date ? blStatus.f7501By : '', f7501Chk: f7501Date ? blStatus.f7501Chk : false})}
              userId={blStatus.f7501By}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <div style={{display: 'flex'}}>
              <div style={{marginLeft: '5px'}}>
                <CheckBox
                  value={blStatus.f3461Chk}
                  onChange={f3461Chk => onChange({
                    f3461Chk,
                    f3461Date: f3461Chk ? now() : null,
                    f3461By: f3461Chk ? user : '',
                  })}
                />
              </div>

              <div style={{width: '110px', marginLeft: '10px', marginRight: '10px'}}>
                <Select
                  value={blStatus.cargoOnBoard}
                  items={[
                    { label: 'Cargo on Board', value: 'Cargo on Board'},
                    { label: 'Flight Delayed', value: 'Flight Delayed'},
                    { label: 'Flight Skipped', value: 'Flight Skipped'},
                    { label: 'Flight Departed', value: 'Flight Departed'},
                  ]}
                  onChange={e => onChange({cargoOnBoard: e.target.value})}
                />
              </div>
              <div style={{width: '180px', display: 'flex'}}>
                <div style={{width: '130px'}}><DateTime disabled={isView || !blStatus.f3461Chk} value={blStatus.f3461Date} onChange={f3461Date => onChange({f3461Date, f3461By: f3461Date ? blStatus.f3461By : '', f3461Chk: f3461Date ? blStatus.f3461Chk : false})} /></div>
                <div style={{width: '50px'}}><TextBox disabled noLeftBorder value={blStatus.f3461By} /></div>
              </div>
            </div>
          </InlineInputControlRowNoLabel>
        </div>
      </div>
    </div>
  );
}

export default React.memo(HawbMilestone);
